import * as types from '../actions/actionTypes.js';
import {getMessage} from "./i18n";

export default (state, action) => {

    switch ( action.type ) {

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/ui.elements.js